module.exports = __webpack_public_path__ + "img/WFH-En.b8a6dfea.png";